









































































import { Component, Vue } from 'vue-property-decorator';
import Button from '@/components/Button.vue';
import TabBar from '@/components/TabBar.vue';
import NavBar from '@/components/NavBar.vue';
import Banner from '@/components/Banner.vue';
import Loader from '@/components/Loader.vue';
import moment from 'moment';
import { Action, Getter, Mutation, namespace, State } from 'vuex-class';
import NewTranslation from '@/components/i18n/NewTranslation.vue';
import i18next from 'i18next';
import TransactionCancelOverlay from '@/views/taxcard/transaction/TransactionCancelOverlay.vue';
import TransactionPrintOverlay from '@/views/taxcard/transaction/TransactionPrintOverlay.vue';
import SocialShare from '@/components/overlays/SocialShare.vue';
import TaxcardEntry from './transaction-overview/TaxcardEntry.vue';
import TransferredTaxcardEntry from '@/views/taxcard/transaction-overview/TransferredTaxcardEntry.vue';
import TransactionCard from '@/views/taxcard/transaction-overview/TransactionCard.vue';
import AppApi from '@/app/api/AppApi';
import CommuneApi from '@/app/api/CommuneApi';
import PrintingApi from '@/app/api/PrintingApi';
import Validity from '@/app/utils/Validity';
import EasyRefresh from 'vue-easyrefresh';
import MobilePaymentApi from '@/app/utils/MobilePaymentApi';
import TransactionExternalReferenceOverlay from '@/views/taxcard/transaction/TransactionExternalReferenceOverlay.vue';

const BookingModule = namespace('booking');

@Component({
  components: {
    TransactionExternalReferenceOverlay,
    TransactionCard,
    TransferredTaxcardEntry,
    SocialShare,
    TransactionPrintOverlay,
    TransactionCancelOverlay,
    NewTranslation,
    Button,
    TabBar,
    NavBar,
    Banner,
    Loader,
    TaxcardEntry,
  },
})
export default class TransactionOverviewView extends Vue {
  public get openFirstValidTicket() {
    return !!this.$route.query.openFirstValidTicket;
  }

  @Getter
  public communeInfo!: () => Promise<any>;

  @Getter
  public translationsLoaded!: boolean;

  @Mutation
  public setUserTransactions!: (transactions: any) => void;

  @Action
  public loadTransactions!: () => Promise<any>;

  @Action
  public loadUserData!: any;

  @State
  public customerUUID!: any;

  @BookingModule.Action
  public resetBooking!: any;

  @BookingModule.Getter('currentBookingSession')
  public bookingSession!: number | null;

  public isTransactionsLoading: boolean = false;

  public isTransactionCanceling: boolean = false;

  public isSocialShareOpen: boolean = false;

  public isCancelOverlayOpen: boolean = false;
  public isPrintOverlayOpen: boolean = false;
  public isExternalReferenceOverlayOpen: boolean = false;

  public transactionForCancellation: any | null = null;
  public transactionForPrinting: any | null = null;
  public transactionForExternalReference: any | null = null;

  public transactions: any[] = [];

  public openTransactionTaxId: string | null = null;

  public socialShareText: string = '';
  public socialShareTitle: string = '';

  public shareIds: string[] = [];

  public easyRefresh!: EasyRefresh;

  public refreshedAt: string = '';

  public mounted() {
    // @ts-ignore
    this.easyRefresh = this.$refs.easyRefresh;
    this.onTranslationLoad(this.triggerRefresh);
    if (MobilePaymentApi.hasMobilePaymentApi() && this.$route.params.purchaseSuccess) {
      MobilePaymentApi.triggerRequestReview();
    }
  }

  public onTranslationLoad(action: () => void) {
    if (this.translationsLoaded) action();
    else
      setTimeout(() => {
        this.onTranslationLoad(action);
      }, 10);
  }

  public triggerRefresh() {
    this.easyRefresh.callRefresh();
  }

  public async handleRefresh(done: () => void = () => {}) {
    try {
      const apiResponse = await this.loadUserData();
      if (apiResponse instanceof Error) throw apiResponse;

      this.transactions = await this.loadTransactions();
      this.refreshedAt = moment().format('HH:mm');
      this.setUserTransactions(this.transactions);

      if (this.openFirstValidTicket && this.transactions && this.transactions.length > 0) {
        const firstValidTransaction = this.transactions.find(t => t.validity === 'current');
        if (firstValidTransaction) {
          this.openTransactionTaxId = firstValidTransaction.taxId;
          this.displayTransaction(firstValidTransaction);
        }
      }
    } catch (e) {
      console.error('Failed to load user data', e);
      done();
      if (this.transactions.length > 0)
        this.openOverlay('Info', {
          title: i18next.t('transactionOverview.refresh.failed.title'),
          message: i18next.t('transactionOverview.refresh.failed.message'),
        });
    } finally {
      this.isTransactionsLoading = false;
      done();
    }
  }

  public onCancelOverlayOpen(transaction: any): void {
    this.isCancelOverlayOpen = true;
    this.transactionForCancellation = transaction;
  }

  public onPrintOverlayOpen(transaction: any): void {
    this.isPrintOverlayOpen = true;
    this.transactionForPrinting = transaction;
  }

  public onExternalReferenceOverlayOpen(transaction: any): void {
    this.isExternalReferenceOverlayOpen = true;
    this.transactionForExternalReference = transaction;
  }

  public onCancelOverlaySubmit({ stayBegin, stayEnd, cancellationDocument, cancellationIban }: any): void {
    this.isTransactionCanceling = true;
    CommuneApi.cancelTransaction(
      this.transactionForCancellation.id,
      this.customerUUID,
      stayBegin,
      stayEnd,
      cancellationDocument,
      cancellationIban
    )
      .then(() => {
        this.isCancelOverlayOpen = false;
        this.$store.commit('openOverlay', {
          overlayName: 'Info',
          overlayData: {
            title: i18next.t('transactionOverview.transaction.cancelDialog.success.title'),
            message: i18next.t('transactionOverview.transaction.cancelDialog.success.body'),
            submit: () => {
              this.isTransactionsLoading = true;
              this.loadTransactions()
                .then(transactions => {
                  this.transactions = transactions;
                })
                .finally(() => {
                  this.isTransactionsLoading = false;
                  this.isCancelOverlayOpen = false;
                  this.transactionForCancellation = null;
                });
            },
          },
        });
      })
      .catch(() => {
        console.log("TRansactionOverviewView error");
        this.isCancelOverlayOpen = false;
        this.$store.commit('openOverlay', {
          overlayName: 'Info',
          overlayData: {
            title: i18next.t('transactionOverview.transaction.cancelDialog.error.title'),
            message: i18next.t('transactionOverview.transaction.cancelDialog.error.body'),
          },
        });
        this.transactionForCancellation = null;
      })
      .finally(() => {
        this.isTransactionCanceling = false;
      });
  }

  public canShowEditButton(): boolean {
    if (this.bookingSession !== null) {
      const now = moment().valueOf();
      return this.bookingSession + 900000 > now; //15 min
      // return this.bookingSession + 180000 > now; //3 min
    }
    return false;
  }

  public onCancelOverlayClose(): void {
    this.isCancelOverlayOpen = false;
    this.transactionForCancellation = null;
  }

  public onPrintOverlayClose(): void {
    this.isPrintOverlayOpen = false;
    this.transactionForPrinting = null;
  }

  public onExternalReferenceOverlayClose(): void {
    this.isExternalReferenceOverlayOpen = false;
    this.transactionForExternalReference = null;
  }

  public onSocialShareOverlayClose(): void {
    this.isSocialShareOpen = false;
  }

  public formatDate(date: string): string {
    const momentDate = moment(date);
    return momentDate.isValid() ? momentDate.format(i18next.t('common.date.format.short')) : 'Ungültiges Datum';
  }

  public displayTransaction(transaction: any) {
    this.$router.push({
      name: 'transactionDetail',
      query: {
        pageData: JSON.stringify(transaction),
      },
    });
  }

  public moment(...args: any[]): any {
    return moment(...args);
  }

  public translate(path: string, params?: any): string {
    return i18next.t(path, params);
  }

  public goToEditBooking() {
    // this.resetBooking();
    this.$router.push({ name: 'booking' });
  }

  public goToBooking() {
    this.resetBooking();
    this.$router.push({ name: 'booking' });
  }

  public shareTaxId({ taxIds, mail, mailOnly }: { taxIds: string[]; mail: string; mailOnly?: boolean }): void {
    const anyWindow = window as any;

    if (mail && Validity.isValidEmail(mail)) {
      this.shareWithMail({ ids: taxIds, mail });
    }

    if (mailOnly) {
      return;
    }

    const taxcardString = taxIds.join(', ');
    const text = i18next.t('transactionOverview.transaction.taxcard.share.message', { taxId: taxcardString });
    // only opens share if on mobile
    AppApi.shareWithApp(anyWindow, text);
  }

  public async shareWithMail({ ids, mail }: { ids: string[]; mail: string }) {
    try {
      const sharedTaxcards: string[] = [];
      interface SharedTaxcard {
        taxId: string;
        code: string;
      }
      await PrintingApi.shareWithMail(ids, mail).then((data: any) => {
        data.forEach((sharedTaxcard: SharedTaxcard) => {
          const sharedTaxcardSummary = `${sharedTaxcard.taxId} PIN ${sharedTaxcard.code}`;
          sharedTaxcards.push(sharedTaxcardSummary);
        });
      });
      const message = [
        i18next.t('transactionOverview.transaction.shareMail.success.message'),
        '<br/>',
        ...sharedTaxcards,
      ].join('<br/>');
      this.openOverlay('Info', {
        title: i18next.t('transactionOverview.transaction.shareMail.success.title'),
        message,
      });
    } catch (error) {
      this.openOverlay('Info', {
        message: i18next.t('transactionOverview.transaction.shareMail.error'),
      });
    }
  }

  private openOverlay(name: string, overlayData: any) {
    this.$store.commit('openOverlay', {
      overlayName: name,
      overlayData,
    });
  }
}
